export default __webpack_public_path__ + "static/media/kitchen5-afterE-768w.cdb508e0.png";